/* My Event Lab — large artwork uploads (25 Oct 2026).
   When a product page adds to the basket with a file attached, the file is first sent to our own file storage
   (the mel-files Cloudflare service, kept for 60 days) in 20MB pieces with a progress bar, and the order gets a
   download link instead of the file. Shopify only accepts files under 20MB, so this lifts that limit.
   If our storage can't be reached, files under 20MB still go to Shopify as before. */
(function () {
  'use strict';
  if (window.__melUpload) return;
  window.__melUpload = true;
  var PART = 20 * 1024 * 1024, SHOPIFY_MAX = 20 * 1000 * 1000;
  var realFetch = window.fetch.bind(window);

  function base() {
    try { var d = JSON.parse(document.getElementById('mel-dc-data').textContent); if (d.urls && d.urls.files) return String(d.urls.files).replace(/\/$/, ''); } catch (e) {}
    return 'https://mel-files.nick-996.workers.dev';
  }
  function mb(n) { return n >= 1048576 ? (n / 1048576).toFixed(n >= 104857600 ? 0 : 1) + 'MB' : Math.max(1, Math.round(n / 1024)) + 'KB'; }

  /* small progress box */
  var box = null, bar = null, txt = null;
  function show(msg, frac) {
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('role', 'status');
      box.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;background:#181357;color:#F6F3EE;border-radius:16px;padding:14px 18px;width:min(420px,calc(100vw - 32px));box-sizing:border-box;font:600 15px/1.4 "Instrument Sans",system-ui,sans-serif;box-shadow:0 12px 32px rgba(24,19,87,.35)';
      txt = document.createElement('div');
      var track = document.createElement('div');
      track.style.cssText = 'margin-top:10px;height:8px;border-radius:99px;background:rgba(246,243,238,.25);overflow:hidden';
      bar = document.createElement('div');
      bar.style.cssText = 'height:100%;width:0;background:#FB97DF;border-radius:99px;transition:width .2s';
      track.appendChild(bar); box.appendChild(txt); box.appendChild(track);
      document.body.appendChild(box);
    }
    txt.textContent = msg;
    bar.style.width = Math.round(Math.max(0, Math.min(1, frac || 0)) * 100) + '%';
  }
  function hide() { if (box && box.parentNode) box.parentNode.removeChild(box); box = null; }

  function api(path, body) {
    return realFetch(base() + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.error || ('HTTP ' + r.status)); return j; }); });
  }
  function putPart(url, blob, onProgress) {
    return new Promise(function (resolve, reject) {
      var tries = 0;
      (function go() {
        var x = new XMLHttpRequest();
        x.open('PUT', url);
        x.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded); };
        x.onload = function () {
          var j = {}; try { j = JSON.parse(x.responseText); } catch (e) {}
          if (x.status >= 200 && x.status < 300 && j.etag) resolve(j);
          else if (++tries < 3) setTimeout(go, 1500 * tries); else reject(new Error(j.error || ('HTTP ' + x.status)));
        };
        x.onerror = function () { if (++tries < 3) setTimeout(go, 1500 * tries); else reject(new Error('Network error')); };
        x.send(blob);
      })();
    });
  }
  /* uploads one file; onProgress(bytesDone) ; resolves to the download link */
  function upload(file, onProgress) {
    var b = base();
    return api('/mpu/create', { name: file.name, type: file.type, size: file.size }).then(function (m) {
      var parts = [], done = 0, n = Math.max(1, Math.ceil(file.size / PART)), i = 0;
      function next() {
        if (i >= n) return api('/mpu/complete', { key: m.key, uploadId: m.uploadId, parts: parts });
        var idx = i++, chunk = file.slice(idx * PART, Math.min(file.size, (idx + 1) * PART));
        var url = b + '/mpu/part?key=' + encodeURIComponent(m.key) + '&uploadId=' + encodeURIComponent(m.uploadId) + '&n=' + (idx + 1);
        return putPart(url, chunk, function (l) { onProgress(done + l); }).then(function (p) {
          done += chunk.size; onProgress(done);
          parts.push({ partNumber: p.partNumber, etag: p.etag });
          return next();
        });
      }
      return next().then(function (r) { return r.url; }, function (err) {
        api('/mpu/abort', { key: m.key, uploadId: m.uploadId }).catch(function () {});
        throw err;
      });
    });
  }

  function isCartAdd(input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    return /\/cart\/add(\.js)?(\?|$)/.test(u) && init && init.body instanceof FormData;
  }

  window.fetch = function (input, init) {
    if (!isCartAdd(input, init)) return realFetch(input, init);
    var fd = init.body, entries = [], files = [];
    fd.forEach(function (v, k) { entries.push([k, v]); if (v instanceof File && v.size > 0) files.push(v); });
    if (!files.length) return realFetch(input, init);
    var total = files.reduce(function (s, f) { return s + f.size; }, 0), before = 0;
    var label = files.length === 1 ? 'your artwork' : files.length + ' files';
    show('Uploading ' + label + '… 0% of ' + mb(total), 0);
    var links = new Map();
    var chain = Promise.resolve();
    files.forEach(function (f) {
      chain = chain.then(function () {
        return upload(f, function (d) { var p = (before + d) / total; show('Uploading ' + label + '… ' + Math.floor(p * 100) + '% of ' + mb(total), p); })
          .then(function (link) { links.set(f, link); }, function (err) {
            if (f.size < SHOPIFY_MAX) { links.set(f, null); return; } // Shopify can still take it
            throw err;
          })
          .then(function () { before += f.size; });
      });
    });
    return chain.then(function () {
      show('Adding to your basket…', 1);
      var out = new FormData(), linked = {};
      entries.forEach(function (e) { if (e[1] instanceof File && links.get(e[1])) linked[e[0]] = 1; });
      entries = entries.filter(function (e) { return !(linked[e[0]] && !(e[1] instanceof File)); });
      entries.forEach(function (e) {
        var k = e[0], v = e[1];
        if (v instanceof File && links.get(v)) {
          out.append(k, links.get(v));
          var m = k.match(/^properties\[(.+)\]$/);
          if (m) out.append('properties[' + m[1] + ' name]', v.name + ' (' + mb(v.size) + ')');
        } else out.append(k, v);
      });
      return realFetch(input, Object.assign({}, init, { body: out }));
    }).then(function (r) { hide(); return r; }, function (err) {
      hide();
      if (window.console) console.error('[MEL upload]', err);
      return Promise.reject({ description: 'Sorry, your file didn\'t upload (' + (err && err.message ? err.message : 'connection problem') + '). Please check your connection and try again, or email it to hello@myeventlab.co.uk after ordering.' });
    });
  };
})();